/**
 * Some variants (particularly on combined/aggregated listings with large,
 * sparse variant matrices) don't have their own featured_media set, even
 * though every color has at least one variant with an image assigned. When
 * that happens the theme's own variant-change handler silently does nothing
 * (no image id to switch to), so the main image appears stuck.
 *
 * This uses a server-rendered color -> fallback media id map (see
 * [data-color-media-fallback] in snippets/product-variant-picker.liquid) to
 * manually trigger the same media-select behavior the theme would have done
 * if the variant had its own image.
 */
(function () {
  function init(productInfo) {
    var mapEl = productInfo.querySelector('[data-color-media-fallback]');
    if (!mapEl) return;

    var colorOptionKey = mapEl.dataset.colorOptionKey;
    if (!colorOptionKey) return;

    var colorMediaMap = {};
    try {
      colorMediaMap = JSON.parse(mapEl.textContent).media || {};
    } catch (error) {
      return;
    }

    if (typeof subscribe !== 'function' || !window.theme || !theme.PUB_SUB_EVENTS) return;

    subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || event.data.sectionId !== productInfo.dataset.section) return;

      var variant = event.data.variant;
      if (!variant || variant.featured_media) return;

      var colorValue = variant[colorOptionKey];
      var fallbackMediaId = colorMediaMap[colorValue];
      if (!fallbackMediaId) return;

      var slide = productInfo.querySelector('[data-image-id="' + fallbackMediaId + '"]');
      if (!slide) return;

      var mediaId = slide.getAttribute('data-media-id');
      slide.dispatchEvent(new CustomEvent('theme:media:select', { bubbles: true, detail: { id: mediaId } }));

      if (!theme.isMobile && window.theme.scrollTo) {
        window.theme.scrollTo(slide.getBoundingClientRect().top);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(init);
  });
})();
